import FaqDetailBanner from './faq-detail-banner';

export default FaqDetailBanner;
